
  
  export const customManagement={ SHAREMESSAGECONTAINER:"/sharemessagecontainer",     
  ADDOFFER:"/addOffers",
  APPOINMENTDASHBOARD:"/appoinmentDashboard",

  SHARESESSAGE:"/shareMessage",
  MYBUSSINESS: "/myBusiness",

  CUSTOMERINFORMATION:"/customerInformation",
  SHARERATECARD:"/shareratecart"
}
export const billerRoute={
  COUNTERSELL: "/countersale",
  
  
}
export const bussinessMangementMenuRoute={
  EXPENCE: "/expence",
  INVENTORY:'/inventory',
  ITEMSERVICES: "/itemServices",
  EMPLOYEEINFO:"/employeeInfo",
  OUTSTANDINGREPORT: "/outstandingReport",
  ASSOCIATEDUSERS: "/associatedUsers",
  EMPLOYEEPAYROLL:"/employeePayroll",
  PAYMENTSTRUCT:"/paymentStruct",
  PURCHASEMANAGMENT:"/purchaseManagement",
  SHAREMESSAGEPROFILE:"/shareEmployeeProfile",
  BULTMESSAGE:"/bulkMessage", 
  BLUESERIVE:"/bulkService",
}
export const analaticsRoute={
  DASHBOARD: "/dashboard",
  REPORTS: "/reports",


}
export const routePath = {
  ROOT: "/*",
  LANDINGPAGE: "/home",
  SERVICES:"/services",
  REVIEWANDRATING:"/ReviewAndRating/:id",
 
  ADVERTICE:"/advertice",



  
  
  LANDINGPAGEHOME: "/homepage",
  SERVICESLIST:"/ServicesList",
  APPOINMENT:"/appoinment",
  OTPFORGET:"/otpforget",
  
  

  REGISTRATION:"/REGISTRATION",
  OTPAPPOINMENT:'/otpappoinment',
  OTP:"/otp",
  SETMPIN:"/setMpin",
  USERPROFILE:"/userprofile",
  LANDINGPAGERESTORENT: "/restorant",
  FAV:'/fav',
  LANDINGPAGECOUNTERTOKEN: "/token",
  
  DETAIL:'/detail',
  LANDINGPAGEMONTHLYBILL: "/monthlybill",
  LANDINGPAGEFRANCHISE: "/franchise",
  LOGIN: "/login",
  ADVANCEPAYMENT:"/advancepayment",
  COUNTERSELLBILLING: "/countersellbilling",
  MYPROFILE: "/myprofile",
  
  MYBUSSINESS: "/myBusiness",
  
  TABLEMASTER: "/tablemaster",
  
  UPDATEBILLS: "/updatebills",
  TABLESECTION: "/table-section",
  ITEMCATEGORIES: "/item-categories",
  PAYMENTRECEIPT: "/payament-receipt",
  MOBILEPAGEMENU: "/mobil-emenu-Page",
  SMBACCOUNTREACHARGE: "/smb-account-reacharge",
  ITEMWISESALE: "/item-wise-sale",
  STOCKS: "/stocks",
  PURCHASE: "/purchase",
  HELPSUPPORT: "/help-support",
  RESETMPIN: "/reset-mpin",
  SETTING: "/setting",
  RATECHANGE: "/rate-change",
  CASHCOUNTERSALE: "/cash-counter-sale",
  KYCPROCESS: "/kyc-process",
  PRIVACYPOLICY:"/privacyPolicy",
  TERMSOFSERVICE:"/termsOfService",

  
  GETOFFERBYBILLER:"/getUserOffer",
  SALARY:'/salary',
  ...customManagement,
  ...analaticsRoute,
  ...bussinessMangementMenuRoute,
  ...billerRoute,
};
